// 我的伙伴页面
import React, { useState, useEffect } from "react";

import { IItemData } from "./common.typing";
import PageTitle from "./PageTitle";
import CommonList from "./CommonList";
import locale from "../../_util/locale";

export interface IMyPartnerProps {
    prePage: string;
    type?: string;
    onChangeCurPage: (page: string) => void;
    currentList: IItemData[];
    setCurrentList: (list: IItemData[]) => void;
    disabledids?: string[];
    requiredList?: IItemData[];
    /** 获取我的伙伴列表 */
    getPartnerList?: () => Promise<any>;
    /** 根据群 id 获取我的伙伴成员 */
    getPartnerMemberList?: (id: number | string, show_external: number) => void;
    setCurrentPartnerInfo: (partner: {
        id: number | string;
        name: string;
    }) => void;
    multiple?: boolean;
}

const MyPartner: React.FC<IMyPartnerProps> = ({
    prePage,
    type,
    onChangeCurPage,
    currentList,
    setCurrentList,
    disabledids,
    requiredList,
    getPartnerList,
    getPartnerMemberList,
    setCurrentPartnerInfo,
    multiple,
}) => {
    const [myPartnerList, setMyPartnerList] = useState([]);

    useEffect(() => {
        loadMyPartnerList();
    }, []);

    const loadMyPartnerList = async () => {
        if (!getPartnerList) return;
        const result = await getPartnerList();
        setMyPartnerList(result);
    };
    /**
     * pageTitle 返回
     * prePage: home
     */
    const onBack = () => {
        onChangeCurPage(prePage);
    };

    /**
     * 群组展示形式的点击时间
     * @param id 群 id
     */
    const onClickPartner = async (id: number | string, name: string) => {
        setCurrentPartnerInfo({ id, name });
        onChangeCurPage("partnerMember");
    };

    return (
        <div className="myGroup">
            {/* <PageTitle
                {...{
                    title: locale("useradd_type_partner"),
                    onBack,
                }}
            /> */}
            <CommonList
                {...{
                    type: "partner",
                    showCheckAll: true,
                    list: myPartnerList,
                    currentList,
                    setCurrentList,
                    disabledids,
                    requiredList,
                    onClickPartner,
                    multiple,
                }}
            />
        </div>
    );
};

export default MyPartner;
